export * from "./Favicon";
